import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "mobile-app-payment-error",
  templateUrl: "./mobile-app-payment-error.component.html"
})
export class MobileAppPaymentErrorComponent implements OnInit {
  ngOnInit() {
  }

  
}


// WEBPACK FOOTER //
// ./src/app/views/mobile-app/payment-error/mobile-app-payment-error.component.ts